// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.figure[data-v-06f9c2af] {\n  display: flex;\n  padding: 40px;\n  justify-content: center;\n}\n", ""]);
// Exports
module.exports = exports;
